import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import withImmutablePropsToJS from 'with-immutable-props-to-js';
import { reduxForm, Field, formValueSelector, change } from 'redux-form/immutable';
import { Textarea } from 'components/Form';
import OptionRadioCheck from 'components/Form/OptionRadioCheck';
import './style.scss';
import validate from './validate';
import PropTypes from 'prop-types';
import { closeRequestEventReasonPopUp } from '../action';
import _ from 'lodash';

class RequestEventForm extends Component {

  componentWillUnmount() {
    this.props.change('reasonEx', '');
    this.props.change('reasonExInput', '');
  }
  handleBlur = () => {
    let reasonStorage = localStorage.getItem('reasonStorage')
      ? JSON.parse(localStorage.getItem('reasonStorage')) : [];
    const eventId = this.props.eventId;

    if (this.props.reason) {
      reasonStorage = localStorage.getItem('reasonStorage') ? JSON.parse(localStorage.getItem('reasonStorage')) : [];
      reasonStorage.unshift({ 'eventId': eventId, 'reason': this.props.reason });
      reasonStorage = _.uniqBy(reasonStorage, 'eventId');
      localStorage.setItem('reasonStorage', JSON.stringify(reasonStorage));

    } else {

      const wait = _.remove(reasonStorage, (item) => {
        return item.eventId === eventId;
      });
      Promise.all(wait).then(() => {
        localStorage.setItem('reasonStorage', JSON.stringify(reasonStorage));
      });

    }
  }

  render() {
    const { reasonEx = '' } = this.props;
    const { reason = '' } = this.props;
    const { handleSubmit, error, valid } = this.props;
    const textareaPlaceholder = '社長の〇〇（生き方・キャリア・ビジョン・事業etc）に共感致しました。（聞いてみたい事or相談したい事）があるのでお会いしたいです。';

    return (
      <div className="request-join-event-form">

        <div className="close-req-join-event" onClick={this.props.closeRequestEventReasonPopUp}>
          <img alt="" src="./images/Quit.svg" />
        </div>

        <div className="form-content-container">
          <div className="join-event-form-title">主催社長へのメッセージ</div>
          <form onSubmit={handleSubmit}>

            <Field
              name="reason"
              component={Textarea}
              maxLength={100}
              className="reason-textarea"
              placeholder={textareaPlaceholder}
              _onBlur={this.handleBlur}
            />

            <div className="join-event-reason-counter"><div>{reason.length}/100</div></div>
            <div className="join-event-form-title">この社長メシに参加する目的</div>

            <Field
              name="reasonEx"
              data={['就職先探し', 'インターン探し', 'ビジョンに共感した', 'その他（自由記入）']}
              component={OptionRadioCheck}
            />

            <Field
              className={`reason-ex-textarea ${reasonEx !== 'その他（自由記入）' && 'reason-ex-hide'}`}
              name="reasonExInput"
              placeholder="コメントを書く…"
              component={Textarea}
              maxLength={100}
            />

            <div className="send-reason-container">
              <button disabled={!valid || error}
                className={` send-reason-btn ${!valid || error ? 'inactive-reason-btn' : 'active-reason-btn'}`}
                type="submit">
                応募完了
              </button>
            </div>

          </form>
        </div>
      </div>
    );
  }
}

RequestEventForm.propTypes = {
  change: PropTypes.func,
  reasonEx: PropTypes.string,
  reason: PropTypes.string,
  closeRequestEventReasonPopUp: PropTypes.func,
  handleSubmit: PropTypes.func,
  error: PropTypes.any,
  valid: PropTypes.bool,
  eventId: PropTypes.string,
  show: PropTypes.bool
};


const mapStateToProps = (state, props) => {
  return {
    reasonEx: (formValueSelector(`requestJoinEventForm-${props.eventId}`))(state, 'reasonEx'),
    reason: (formValueSelector(`requestJoinEventForm-${props.eventId}`))(state, 'reason'),
    show: state.get('requestReason').get('show')

  };
};

const mapDispatchToProps = (dispatch, props) => {
  return {
    closeRequestEventReasonPopUp: () => dispatch(closeRequestEventReasonPopUp()),
    change: (field, value) => dispatch(change(`requestJoinEventForm-${props.eventId}`, field, value))
  };
};

export default compose(
  connect((state, props) =>
    ({ form: `requestJoinEventForm-${props.eventId}` })),
  reduxForm({
    validate,
    destroyOnUnmount: false,
    enableReinitialize: true
  }),
  withImmutablePropsToJS
)(connect(mapStateToProps, mapDispatchToProps)(RequestEventForm));